import React from 'react';

import PageHeader from '../components/PageHeader';
import Search from '../components/Search';

import './styles/search.scss';

const SearchPage = ({ data, defaultPreview }) => {
  const { allMarkdownRemark, siteSearchIndex } = data;

  return (
    <div className="main searchPage" >
      <PageHeader title="Rechercher un article" />

      <Search
        edges={allMarkdownRemark.edges}
        searchData={siteSearchIndex}
        defaultPreview={defaultPreview}
      />
    </div>
  );
}

export default SearchPage;


export const query = graphql`
  query SearchPageQuery {
    siteSearchIndex {
      index
    }
    allMarkdownRemark(
        sort: {fields: [frontmatter___date], order: DESC},
        filter: {fileAbsolutePath: {regex: "/(posts)/.*\\.md$/"}, frontmatter: { published: {eq: "true"}}}
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM YYYY", locale: "fr")
            description
            banner {
              childImageSharp {
                sizes(maxWidth: 300, maxHeight: 200, cropFocus: CENTER) {
                  ...GatsbyImageSharpSizes
                }
              }
            } 
          }
          fields {
            slug
          }
          headings {
            depth
            value
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/search.jsx